import 'css-chunksrc/feature/notification/PrintFailureToastNotification.module.scss';export default {
  "root": "PrintFailureToastNotification_root"
};